export const CONTRACT_TYPES = ['fixedTerm', 'permanent', 'internship', 'apprenticeship', 'freelance'];
